/* ============================================================
   Quelton — ficha de producto (sobre Dawn). Portada de ~/Quelton-paginaweb/assets/js/producto.js.
   Galería con miniaturas / carrusel en móvil · zoom · opciones de top y braguita
   · aviso de stock REAL debajo de las tallas (solo agotado, pocas unidades o últimas unidades)
   · añadir a la cesta (Ajax) · "Completa tu look" · fecha de entrega · compartir
   · tarjeta flotante de compra · panel que acompaña a las fotos · "Más colores de este corte"
   · stock en vivo · vistos recientemente · looks de clientas (sección q-pdp-looks).
   ============================================================ */
(function () {
  'use strict';
  const Q = window.Q;
  const root = document.querySelector('[data-pdp]');
  if (!Q || !root) return;
  const { money, esc, toast, getProduct, findVariant, valueAvailable, prefillSizes, Cart, Size, reduceMotion, registerProducts } = Q;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const S = {};
  $$('script[data-pdp-strings], script[data-q-pdp-strings]').forEach((el) => { try { Object.assign(S, JSON.parse(el.textContent)); } catch (e) { /* sin textos: se usan los de reserva */ } });
  // mientras una cadena nueva no esté en locales/, Shopify devuelve "translation missing": se usa la de reserva
  const tr = (k, fb) => (S[k] && !/translation missing/i.test(S[k]) ? S[k] : fb);
  const base = (window.QTHEME && window.QTHEME.routes && window.QTHEME.routes.root) || '/';

  const p = getProduct(root.dataset.product);
  if (!p) return;
  const LOW_STOCK = Number(root.dataset.lowStock) || 5;
  const isLast = root.hasAttribute('data-last-units');

  // ---------- vistos recientemente (solo en este navegador) ----------
  const Recent = {
    get() { try { return JSON.parse(localStorage.getItem('quelton-recent')) || []; } catch { return []; } },
    add(h) { try { localStorage.setItem('quelton-recent', JSON.stringify([h, ...this.get().filter((x) => x !== h)].slice(0, 12))); } catch {} },
  };
  const recentBefore = Recent.get().filter((h) => h !== p.handle);
  Recent.add(p.handle);

  // ---------- selección ----------
  const sel = {};
  p.options.forEach((o) => { if (o.values.length === 1) sel[o.index] = o.values[0]; });
  // si la URL trae ?variant=, se respeta
  const urlVariant = Number(new URLSearchParams(location.search).get('variant'));
  const preset = urlVariant && p.v.find((v) => v[0] === urlVariant);
  if (preset) p.options.forEach((o) => { sel[o.index] = preset[1][o.index]; });
  else prefillSizes(p, sel);
  // el buscador de talla puede añadir este producto a la cesta con las tallas que calcule
  Q.quizContext = { product: p, sel, apply: (s2) => { Object.assign(sel, s2); render(); } };

  const ICON = {
    ruler: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="8" width="18" height="8" rx="1.5" stroke="currentColor" stroke-width="1.5"/><path d="M7 8v3M11 8v4M15 8v3M19 8v2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
  };
  const STYLE_ICON = {
    'Básica': '<svg width="28" height="16" viewBox="0 0 28 16" fill="none" aria-hidden="true"><path d="M2 3h24c-2 6-6 11-12 11S4 9 2 3z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>',
    'Tanga': '<svg width="28" height="16" viewBox="0 0 28 16" fill="none" aria-hidden="true"><path d="M2 3h24c-4 4-8 6-10 11h-4C10 9 6 7 2 3z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>',
  };
  const styleName = (v) => (/tanga|thong/i.test(v) ? 'Tanga' : /basic|básic/i.test(v) ? 'Básica' : v);
  const styleLabel = (v) => { const n = styleName(v); return n === 'Básica' ? Q.t('basic', 'Básica') : n; };

  // chips de talla y botones de estilo; prefix distingue panel (''), look ('l'), tarjeta flotante ('s') y looks de clientas ('g')
  function optionsHTML(prod, s, prefix) {
    const mine = Size.get();
    return prod.options.map((o, i) => {
      const isStyle = o.kind === 'style';
      const chosen = s[o.index];
      return `
      <div class="pdp-opt">
        <div class="pdp-opt__head">
          <span>${esc(o.label)}${chosen ? `: <b>${esc(isStyle ? styleLabel(chosen) : chosen)}</b>` : ''}</span>
          ${!prefix && i === 0 && o.kind === 'size' ? `<button type="button" class="link-btn" data-quiz-open>${ICON.ruler} ${esc(tr('size_guide', 'Guía de tallas'))}</button>` : ''}
        </div>
        <div class="${isStyle ? 'styles' : 'chips chips--lg'}">${o.values.map((v) => {
          const ok = valueAvailable(prod, s, o, v);
          const isMine = !isStyle && mine && (o.part === 'bottom' || prod.k === 'braguita' ? mine.bottom : mine.top) === v;
          return isStyle
            ? `<button type="button" class="style-btn" data-${prefix}opt="${o.index}" data-val="${esc(v)}" aria-pressed="${chosen === v}" ${ok ? '' : 'disabled'}>${STYLE_ICON[styleName(v)] || ''}<span>${esc(styleLabel(v))}</span></button>`
            : `<button type="button" class="chip${isMine ? ' is-mine' : ''}" data-${prefix}opt="${o.index}" data-val="${esc(v)}" aria-pressed="${chosen === v}" ${ok ? '' : `disabled title="${esc(tr('sold_out', 'Agotada'))}"`}>${esc(v)}</button>`;
        }).join('')}</div>
      </div>`;
    }).join('');
  }

  function missingLabel(prod, s) {
    const m = prod.options.filter((o) => s[o.index] === undefined);
    if (!m.length) return '';
    if (m.length > 1) return tr('choose_sizes', 'Elige tus tallas');
    return m[0].kind === 'style' ? tr('choose_style', 'Elige el estilo de braguita') : `${tr('choose_one', 'Elige')} ${m[0].label.toLowerCase()}`;
  }
  const isComplete = (prod, s) => prod.options.every((o) => s[o.index] !== undefined);
  // variante elegida (o la única, si el producto no tiene opciones)
  const chosenVariant = (prod, s) => (isComplete(prod, s) ? findVariant(prod, s) : null) || (!prod.options.length ? prod.v[0] : null);
  const toggleSel = (s, btn, attr) => { const i = Number(btn.dataset[attr]); s[i] = s[i] === btn.dataset.val ? undefined : btn.dataset.val; };
  const newSel = (prod) => { const s2 = {}; prod.options.forEach((o) => { if (o.values.length === 1) s2[o.index] = o.values[0]; }); prefillSizes(prod, s2); return s2; };

  // Aviso de stock, justo debajo de las tallas. Solo sale cuando aporta algo:
  //  · producto agotado entero: "Agotado. Esta edición no se va a reponer."
  //  · combinación agotada: "Agotado en esta combinación de tallas." + formulario "Avísame"
  //  · pocas unidades REALES de la talla elegida (variant.inventory_quantity ≤ umbral): "Solo quedan N unidades en tu talla"
  //  · producto de la colección de últimas unidades: "Últimas unidades de esta edición"
  // Nada más (ya no hay "En stock | Recíbelo en 24–48 h"). Las unidades nunca se inventan.
  function stockHTML(variant) {
    if (!p.available) return `<p class="stock stock--out">${esc(tr('sold_out_all', 'Agotado. Esta edición no se va a reponer.'))}</p>`;
    if (variant && !variant[4]) return `<div class="stock stock--out"><p>${esc(tr('sold_out_combo', 'Agotado en esta combinación de tallas.'))}</p><div data-notify-slot></div></div>`;
    const qty = variant && variant[5];
    if (Number.isFinite(qty) && qty > 0 && qty <= LOW_STOCK) {
      const tpl = qty === 1 ? tr('low_one', '<b>Solo queda [n] unidad</b> en tu talla') : tr('low_many', '<b>Solo quedan [n] unidades</b> en tu talla');
      return `<p class="stock stock--low"><span class="dot"></span>${tpl.replace('[n]', `<span data-qty-count="${qty}">${qty}</span>`)}</p>`;
    }
    if (isLast) return `<p class="stock stock--low"><span class="dot"></span>${tr('last_units', '<b>Últimas unidades</b> de esta edición')}</p>`;
    return '';
  }
  // cuenta escalonada desde el número que se veía hasta el real (p. ej. al pasar de la talla S a la M)
  let shownQty = null;
  function animateQty() {
    const el = $('[data-qty-count]', root);
    if (!el) { shownQty = null; return; }
    const target = Number(el.dataset.qtyCount);
    const from = shownQty;
    shownQty = target;
    if (from === null || from === target || reduceMotion) return;
    let cur = from;
    el.textContent = cur;
    const step = () => {
      if (!el.isConnected) return;
      cur += cur < target ? 1 : -1;
      el.textContent = cur;
      el.parentElement.classList.remove('is-tick'); void el.offsetWidth; el.parentElement.classList.add('is-tick');
      if (cur !== target) setTimeout(step, 140);
    };
    setTimeout(step, 140);
  }

  // ---------- panel ----------
  const optBox = $('[data-options]', root);
  const stockBox = $('[data-stock]', root);
  const addBtn = $('[data-add]', root);
  const idInput = $('[data-variant-id]', root);
  const priceEl = $('[data-price]', root);
  const compareEl = $('[data-compare]', root);
  const thirdEl = $('[data-third]', root);
  const fitBtn = $('[data-fit]', root);
  const current = () => (isComplete(p, sel) ? findVariant(p, sel) : null);
  const buyForm = $('[data-buy]', root) || $('form.pdp-buy', root);

  function render() {
    const complete = isComplete(p, sel);
    const variant = current();
    const price = variant ? variant[2] : p.price;
    const compare = variant ? variant[3] : p.compare;
    const canBuy = !!(variant && variant[4]);

    optBox.innerHTML = optionsHTML(p, sel, '');
    stockBox.innerHTML = stockHTML(variant);
    const slot = $('[data-notify-slot]', stockBox);
    const tpl = $('[data-notify-tpl]');
    if (slot && tpl) {
      slot.appendChild(tpl.content.cloneNode(true));
      const body = $('[data-notify-body]', slot);
      if (body) body.value = `${tr('notify_body', 'Avísame cuando vuelva')} · ${p.options.map((o) => `${o.label}: ${sel[o.index]}`).join(' · ')}`;
    }

    priceEl.textContent = money(price);
    if (compareEl) { compareEl.hidden = !(compare > price); compareEl.textContent = money(compare); }
    if (thirdEl) thirdEl.textContent = money(Math.ceil((price / 3) * 100) / 100);
    if (fitBtn) fitBtn.hidden = !!Size.get();

    if (variant) idInput.value = variant[0];
    addBtn.disabled = !p.available || (complete && !canBuy);
    addBtn.textContent = !p.available ? tr('sold_out', 'Agotado')
      : complete ? (canBuy ? `${tr('add', 'Añadir a la cesta')} · ${money(price)}` : tr('sold_out_size', 'Agotado en esta talla')) : missingLabel(p, sel);
    // el pago exprés solo tiene sentido con la talla elegida
    root.classList.toggle('is-incomplete', !canBuy);

    if (variant && history.replaceState && !window.Shopify?.designMode) {
      const url = new URL(location.href);
      url.searchParams.set('variant', variant[0]);
      history.replaceState(history.state, '', url);
    }
    renderSticky();
    animateQty();
  }

  function goToOptions() {
    window.scrollTo({ top: optBox.getBoundingClientRect().top + scrollY - 120, behavior: reduceMotion ? 'auto' : 'smooth' });
    optBox.classList.add('is-flash');
    setTimeout(() => optBox.classList.remove('is-flash'), 1200);
  }

  root.addEventListener('click', (e) => {
    const opt = e.target.closest('[data-opt]');
    if (opt) { toggleSel(sel, opt, 'opt'); render(); }
  });

  buyForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const v = current();
    if (!v || !v[4]) { goToOptions(); return; }
    addBtn.classList.add('is-loading');
    Cart.add(v[0]).finally(() => addBtn.classList.remove('is-loading'));
  });
  // "Comprar ya": añade la talla elegida y va directo al pago
  $('[data-buy-now]', root)?.addEventListener('click', (e) => {
    const v = current();
    if (!v || !v[4]) { goToOptions(); return; }
    const btn = e.currentTarget;
    btn.classList.add('is-loading');
    fetch(`${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}cart/add.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v[0], quantity: 1 }] }),
    }).then((r) => { if (!r.ok) throw new Error(); window.location.href = '/checkout'; })
      .catch(() => btn.classList.remove('is-loading'));
  });
  // el botón de pago exprés de Shopify usa el mismo formulario: sin talla elegida, se pide antes
  buyForm.addEventListener('click', (e) => {
    if (e.target.closest('.shopify-payment-button') && !(current() && current()[4])) { e.preventDefault(); e.stopPropagation(); goToOptions(); }
  }, true);

  // ---------- compartir ----------
  $('[data-share]', root)?.addEventListener('click', async () => {
    const url = location.href.split('?')[0];
    const data = { title: p.t, text: `${tr('share_text', 'Mira este bikini de Quelton 😍')} ${p.t}`, url };
    try {
      if (navigator.share) { await navigator.share(data); return; }
      await navigator.clipboard.writeText(url);
      toast(tr('copied', 'Enlace copiado: mándaselo a tu amiga 💌'));
    } catch { /* la clienta canceló */ }
  });

  // ---------- galería ----------
  const gallery = $('[data-gallery]', root);
  const photos = $$('[data-photo]', gallery);
  const counter = $('[data-counter]', root);
  $$('[data-thumb]', root).forEach((b) => b.addEventListener('click', () => {
    const target = photos[Number(b.dataset.thumb)];
    if (!target) return;
    // en móvil la galería es un carrusel horizontal; en ordenador se baja hasta la foto
    if (gallery.scrollWidth > gallery.clientWidth + 10) { gallery.scrollTo({ left: target.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' }); return; }
    const headerH = ($('.q-header-section')?.getBoundingClientRect().height) || 76;
    window.scrollTo({ top: target.getBoundingClientRect().top + scrollY - headerH, behavior: reduceMotion ? 'auto' : 'smooth' });
  }));
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (!en.isIntersecting) return;
      const i = en.target.dataset.photo;
      $$('[data-thumb]', root).forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === i));
    }), { rootMargin: '-45% 0px -45% 0px' });
    photos.forEach((ph) => io.observe(ph));
  }
  gallery.addEventListener('scroll', () => {
    if (!photos.length || !counter) return;
    const w = photos[0].getBoundingClientRect().width + 6;
    counter.textContent = `${Math.min(photos.length, Math.round(gallery.scrollLeft / w) + 1)} / ${photos.length}`;
  }, { passive: true });

  // zoom (solo fotos; los vídeos no se abren)
  const lb = $('[data-lightbox]');
  const lbTrack = lb && $('.lightbox__track', lb);
  const imagePhotos = photos.filter((ph) => ph.tagName === 'BUTTON');
  let lbReturn = null;
  gallery.addEventListener('click', (e) => {
    const ph = e.target.closest('button[data-photo]');
    if (!ph || !lb) return;
    lbReturn = ph;
    lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false'); document.body.classList.add('is-locked');
    const idx = imagePhotos.indexOf(ph);
    requestAnimationFrame(() => { const el = lbTrack.children[idx]; if (el) lbTrack.scrollTop = el.offsetTop; $('[data-lightbox-close]', lb)?.focus(); });
  });
  const closeLb = () => {
    if (!lb || !lb.classList.contains('is-open')) return;
    lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); document.body.classList.remove('is-locked');
    lbReturn?.focus();
  };
  $('[data-lightbox-close]')?.addEventListener('click', closeLb);
  document.addEventListener('keydown', (e) => e.key === 'Escape' && closeLb());

  // ---------- fecha de entrega (días laborables: compra → preparación → entrega) ----------
  const delivery = $('[data-delivery]', root);
  if (delivery) {
    const addBusinessDays = (d, n) => { const r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6) n--; } return r; };
    const locale = (window.QTHEME && window.QTHEME.locale) || 'es-ES';
    const fmt = (d) => { try { return d.toLocaleDateString(locale, { day: 'numeric', month: 'short' }).replace('.', ''); } catch { return d.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' }).replace('.', ''); } };
    const today = new Date();
    const ship = addBusinessDays(today, Number(delivery.dataset.prep) || 0);
    const a = addBusinessDays(ship, Number(delivery.dataset.min) || 1);
    const b = addBusinessDays(ship, Math.max(Number(delivery.dataset.max) || 2, Number(delivery.dataset.min) || 1));
    $('[data-d="0"]', delivery).textContent = fmt(today);
    $('[data-d="1"]', delivery).textContent = fmt(ship);
    $('[data-d="2"]', delivery).textContent = +a === +b ? fmt(a) : `${fmt(a)} – ${fmt(b)}`;
  }

  // ---------- completa tu look (como The-Are) ----------
  // Top suelto → su braguita; braguita suelta → su(s) top(s) (triángulo antes que sporty); después ropa.
  // Bikini completo → ropa. Hasta 3 piezas, con su primera foto (packshot con fondo blanco).
  // Primer clic en "Añadir al carrito": se despliegan las tallas (con la talla guardada ya marcada); segundo: se añade.
  const lookBox = $('[data-look-box]', root);
  const lookList = lookBox && $('[data-look-items]', lookBox);
  let lookCfg = {};
  try { lookCfg = JSON.parse($('script[data-q-look]').textContent); } catch (e) { /* sin datos */ }
  let lookItems = [];
  const partnerKind = p.k === 'top' ? 'braguita' : p.k === 'braguita' ? 'top' : null;
  // ropa de verdad (algún bikini está mal catalogado como ropa en la tienda: fuera)
  const isClothes = (q) => q.k === 'ropa' && !/bikini|bañador|swimsuit|^braguita|^bottom|^top (triángulo|triangl|sporty|balconette)/i.test(q.t);

  function buildLook(candidates) {
    const out = [];
    const push = (q) => { if (q && q.handle !== p.handle && q.available && !out.includes(q)) out.push(q); };
    const cands = candidates.map(getProduct).filter(Boolean);
    if (partnerKind) cands.filter((q) => q.k === partnerKind).sort((a, b) => (a.shape === 'Sporty') - (b.shape === 'Sporty')).forEach(push);
    [...cands, ...(lookCfg.fill || []).map(getProduct)].filter((q) => q && isClothes(q)).forEach(push);
    lookItems = out.slice(0, 3).map((q) => ({ p: q, sel: newSel(q), open: false }));
    renderLook();
  }
  function renderLook() {
    if (!lookBox) return;
    lookBox.hidden = !lookItems.length;
    lookList.innerHTML = lookItems.map((it, i) => {
      const q = it.p;
      const complete = isComplete(q, it.sel);
      const v = chosenVariant(q, it.sel);
      const label = !q.options.length || (complete && it.open)
        ? (v && v[4] ? tr('add_cart', 'Añadir al carrito') : tr('sold_out_size', 'Agotado en esta talla'))
        : (it.open ? missingLabel(q, it.sel) || tr('choose_size', 'Elige tu talla') : tr('add_cart', 'Añadir al carrito'));
      return `<div class="look-item" data-li="${i}">
        <a class="look-item__img" href="${q.url}" tabindex="-1" aria-hidden="true"><img src="${Q.img(q.img[0], 240)}" alt="" loading="lazy"></a>
        <div class="look-item__info">
          <a class="look-item__name" href="${q.url}">${esc(q.t)}</a>
          <span class="look-item__price">${money(v ? v[2] : q.price)}</span>
          ${it.open ? `<div class="look-item__opts">${optionsHTML(q, it.sel, 'l')}</div>` : ''}
          <button type="button" class="look-item__add" data-li-add="${i}" aria-label="${esc(`${label}: ${q.t}`)}" ${(it.open || !q.options.length) && complete && !(v && v[4]) ? 'disabled' : ''}>${esc(label)}</button>
        </div>
      </div>`;
    }).join('');
  }
  lookBox?.addEventListener('click', (e) => {
    const row = e.target.closest('[data-li]');
    if (!row) return;
    const it = lookItems[Number(row.dataset.li)];
    const lopt = e.target.closest('[data-lopt]');
    if (lopt) { toggleSel(it.sel, lopt, 'lopt'); renderLook(); return; }
    const ladd = e.target.closest('[data-li-add]');
    if (!ladd) return;
    if (!it.open && it.p.options.some((o) => o.values.length > 1)) { it.open = true; renderLook(); $(`[data-li="${row.dataset.li}"] .look-item__opts button:not([disabled])`, lookBox)?.focus(); return; }
    const v = chosenVariant(it.p, it.sel);
    if (v && v[4]) { ladd.disabled = true; Cart.add(v[0]).finally(() => { it.open = false; renderLook(); }); }
  });
  if (lookBox) {
    if ((lookCfg.meta || []).length) buildLook(lookCfg.meta);
    else {
      // sin metacampo: complementarios de Shopify (Search & Discovery) a través de la sección q-pdp-complementary
      fetch(`${base}recommendations/products?product_id=${root.dataset.productId}&intent=complementary&limit=6&section_id=${encodeURIComponent(lookCfg.section || 'q-pdp-complementary')}`)
        .then((r) => (r.ok ? r.text() : ''))
        .then((html) => {
          const handles = [];
          if (html) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            doc.querySelectorAll('script[data-q-product]').forEach((s) => {
              try { const d = JSON.parse(s.textContent); if (!Q.DATA.products[d.handle]) Q.DATA.products[d.handle] = d; handles.push(d.handle); } catch (e) { /* JSON roto */ }
            });
          }
          buildLook(handles);
        })
        .catch(() => buildLook([]));
    }
  }

  // ---------- "Más colores de este corte" (barra fija abajo a la izquierda en ordenador) ----------
  // Se esconde al bajar y vuelve al subir. En ordenador comparte el hueco con la tarjeta de compra:
  // la tarjeta sale cuando esta barra se ha escondido y la clienta ha bajado ~160 px más.
  const similar = $('[data-similar]');
  let similarHiddenAt = null;
  if (similar) {
    document.body.classList.add('has-similar');
    let lastY = window.scrollY, tickS = false;
    window.addEventListener('scroll', () => {
      if (tickS) return;
      tickS = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        if (Math.abs(y - lastY) > 6) {
          const hide = y > lastY && y > 80;
          if (hide && similarHiddenAt === null) similarHiddenAt = y;
          if (!hide) similarHiddenAt = null;
          similar.classList.toggle('is-hidden', hide);
          lastY = y;
        }
        tickS = false;
      });
    }, { passive: true });
  }

  // ---------- tarjeta flotante de compra (móvil y ordenador, como The-Are) ----------
  // Foto, nombre, precio y "Añadir al carrito". Si falta la talla, se despliegan las tallas dentro
  // de la propia tarjeta (comparten la selección con el panel), sin volver arriba.
  const sticky = $('[data-sticky-buy]');
  let stickyOpen = false;
  function renderSticky() {
    if (!sticky) return;
    const complete = isComplete(p, sel);
    const variant = current();
    const canBuy = !!(variant && variant[4]);
    const price = variant ? variant[2] : p.price;
    const soldOut = !p.available;
    const label = soldOut ? tr('sold_out', 'Agotado') : complete ? (canBuy ? tr('add_cart', 'Añadir al carrito') : tr('sold_out', 'Agotado'))
      : stickyOpen ? missingLabel(p, sel) : tr('add_cart', 'Añadir al carrito');
    sticky.innerHTML = `
      <div class="sticky-buy__row">
        <img src="${Q.img(p.img[0], 160)}" alt="">
        <div class="sticky-buy__info"><p>${esc(p.t)}</p><span>${money(price)}</span></div>
        <button class="sticky-buy__add" type="button" data-sticky-add aria-expanded="${stickyOpen}" ${soldOut || (complete && !canBuy) ? 'disabled' : ''}>${esc(label)}</button>
      </div>
      ${stickyOpen ? `<div class="sticky-buy__opts">${optionsHTML(p, sel, 's')}</div>` : ''}`;
    sticky.classList.toggle('is-open', stickyOpen);
  }
  if (sticky) {
    sticky.addEventListener('click', (e) => {
      const opt = e.target.closest('[data-sopt]');
      if (opt) {
        const key = `[data-sopt="${opt.dataset.sopt}"][data-val="${CSS.escape(opt.dataset.val)}"]`;
        toggleSel(sel, opt, 'sopt'); render();
        $(key, sticky)?.focus();
        return;
      }
      if (!e.target.closest('[data-sticky-add]')) return;
      const v = current();
      if (v && v[4]) { Cart.add(v[0]).finally(() => { stickyOpen = false; renderSticky(); }); return; }
      if (!isComplete(p, sel)) { stickyOpen = true; renderSticky(); $('.sticky-buy__opts button:not([disabled])', sticky)?.focus(); }
    });
    // aparece cuando el botón principal de compra ya ha quedado por encima de la pantalla y se quita al llegar al pie
    let tick = false;
    const check = () => {
      tick = false;
      const buy = buyForm;
      const foot = $('.site-footer');
      let show = !!buy && buy.getBoundingClientRect().bottom < 0 && !(foot && foot.getBoundingClientRect().top < innerHeight);
      const similarShown = similar && getComputedStyle(similar).display !== 'none';
      if (show && similarShown) show = similarHiddenAt !== null && scrollY - similarHiddenAt > 160;
      if (!show && stickyOpen && !sticky.contains(document.activeElement)) { stickyOpen = false; renderSticky(); }
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      sticky.inert = !show;
      document.body.classList.toggle('has-sticky-buy', show);
    };
    window.addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  // ---------- stock en vivo ----------
  // Cada minuto (y al volver a la pestaña) se vuelve a pedir esta sección a Shopify y se leen las unidades reales.
  // Si alguien ha comprado esa talla, el número baja; si se repone, sube.
  async function refreshStock() {
    try {
      const res = await fetch(`${location.pathname}?section_id=${encodeURIComponent(root.dataset.section)}`, { headers: { Accept: 'text/html' } });
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = Array.from(doc.querySelectorAll('script[data-q-product]')).map((s) => { try { return JSON.parse(s.textContent); } catch { return null; } })
        .find((d) => d && d.handle === p.handle);
      if (!fresh) return;
      let changed = false;
      fresh.v.forEach((fv) => {
        const v = p.v.find((x) => x[0] === fv[0]);
        if (v && (v[4] !== fv[4] || v[5] !== fv[5])) { v[4] = fv[4]; v[5] = fv[5]; changed = true; }
      });
      if (changed) { p.available = p.v.some((v) => v[4]); render(); }
    } catch (e) { /* sin conexión: se queda el dato anterior */ }
  }
  if (!window.Shopify?.designMode) {
    setInterval(() => { if (document.visibilityState === 'visible') refreshStock(); }, 60000);
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') refreshStock(); });
  }

  document.addEventListener('quelton:size', () => {
    prefillSizes(p, sel);
    lookItems.forEach((it) => prefillSizes(it.p, it.sel));
    renderLook();
    render();
  });
  render();

  // ---------- panel que acompaña a las fotos ----------
  // Si cabe en la pantalla, se queda fijo bajo la cabecera; si es más alto, baja con la página
  // hasta que se ve su final y ahí se queda fijo mientras siguen pasando las fotos.
  const panelEl = $('[data-panel]', root);
  function fitPanel() {
    if (!panelEl) return;
    if (!window.matchMedia('(min-width: 901px)').matches) { panelEl.style.top = ''; return; }
    const headerH = ($('.q-header-section')?.getBoundingClientRect().height) || 68;
    panelEl.style.top = `${Math.min(headerH, window.innerHeight - panelEl.offsetHeight)}px`;
  }
  fitPanel();
  window.addEventListener('resize', fitPanel);
  if ('ResizeObserver' in window && panelEl) new ResizeObserver(fitPanel).observe(panelEl);

  // ---------- vistos recientemente ----------
  const recentBox = $('[data-recent]');
  if (recentBox && recentBefore.length) {
    const limit = Number(recentBox.dataset.limit) || 8;
    Promise.all(recentBefore.slice(0, limit).map((h) => fetch(`${base}products/${encodeURIComponent(h)}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)))
      .then((list) => {
        const items = list.filter(Boolean);
        if (!items.length) return;
        recentBox.innerHTML = items.map((r) => `
          <article class="pcard">
            <div class="pcard__media"><a class="pcard__track" href="${r.url}"><img src="${Q.img(r.featured_image && r.featured_image.startsWith('//') ? `https:${r.featured_image}` : r.featured_image, 600)}" alt="${esc(r.title)}" loading="lazy"></a></div>
            <div class="pcard__info"><div><h3 class="pcard__title"><a href="${r.url}">${esc(r.title)}</a></h3></div><span class="pcard__price">${money(r.price / 100)}</span></div>
          </article>`).join('');
        recentBox.closest('[data-recent-wrap]').hidden = false;
      });
  }

  // ---------- looks de clientas "Así lo llevan las #IconicQueltons" (sección q-pdp-looks) ----------
  // Al pasar el cursor (o tocar la bolsa en el móvil) sube un panel blanco con lo que lleva puesto.
  // Primer clic en "Añadir al carrito": se despliegan las tallas (con su talla guardada ya marcada); segundo: se añade.
  function initLooks(sec) {
    if (!sec || sec._qLooks) return;
    sec._qLooks = true;
    const rail = $('[data-looks-rail]', sec);
    if (!rail) return;
    const cards = $$('[data-gl]', sec).map((card) => ({
      card,
      items: (card.dataset.glProducts || '').split(',').filter(Boolean).map(getProduct).filter(Boolean).map((q) => ({ p: q, sel: newSel(q), open: false })),
    }));
    const stepW = () => (rail.firstElementChild ? rail.firstElementChild.getBoundingClientRect().width + 16 : 300);
    $('[data-looks-prev]', sec)?.addEventListener('click', () => rail.scrollBy({ left: -stepW(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    $('[data-looks-next]', sec)?.addEventListener('click', () => rail.scrollBy({ left: stepW(), behavior: reduceMotion ? 'auto' : 'smooth' }));

    function renderBuy(ci) {
      const c = cards[ci];
      c.card.classList.toggle('is-open', c.items.some((it) => it.open));
      $('[data-gl-buy]', c.card).innerHTML = c.items.map((it, ii) => {
        const q = it.p;
        const complete = isComplete(q, it.sel);
        const v = chosenVariant(q, it.sel);
        const soldOut = !q.available;
        const label = soldOut ? tr('sold_out', 'Agotado') : it.open && !complete ? missingLabel(q, it.sel) : complete && !(v && v[4]) ? tr('sold_out', 'Agotado') : tr('add_cart', 'Añadir al carrito');
        return `
        <div class="ugc-look__item" data-gi="${ii}">
          <a class="ugc-look__product" href="${q.url}">
            <img src="${Q.img(q.img[0], 160)}" alt="" loading="lazy">
            <span><b>${esc(q.t)}</b>${money(v ? v[2] : q.price)}</span>
          </a>
          ${it.open ? `<div class="ugc-look__opts">${optionsHTML(q, it.sel, 'g')}</div>` : ''}
          <button class="ugc-look__add" type="button" data-gi-add ${soldOut || (complete && !(v && v[4])) ? 'disabled' : ''}>${esc(label)}</button>
        </div>`;
      }).join('');
    }
    cards.forEach((_, ci) => renderBuy(ci));
    sec.addEventListener('click', (e) => {
      const card = e.target.closest('[data-gl]');
      if (!card) return;
      const ci = Number(card.dataset.gl);
      const c = cards[ci];
      if (!c) return;
      const toggle = e.target.closest('[data-gl-toggle]');
      if (toggle) {
        const willOpen = !card.classList.contains('is-touch-open');
        card.classList.toggle('is-touch-open', willOpen);
        toggle.setAttribute('aria-expanded', String(willOpen));
        if (!willOpen) { c.items.forEach((it) => { it.open = false; }); renderBuy(ci); }
        else $('[data-gi-add]', card)?.focus();
        return;
      }
      const row = e.target.closest('[data-gi]');
      if (!row) return;
      const it = c.items[Number(row.dataset.gi)];
      const opt = e.target.closest('[data-gopt]');
      if (opt) { toggleSel(it.sel, opt, 'gopt'); renderBuy(ci); return; }
      const add = e.target.closest('[data-gi-add]');
      if (!add) return;
      if (!it.open && it.p.options.some((o) => o.values.length > 1)) { it.open = true; renderBuy(ci); $(`[data-gi="${row.dataset.gi}"] .ugc-look__opts button:not([disabled])`, card)?.focus(); return; }
      const v = chosenVariant(it.p, it.sel);
      if (v && v[4]) {
        add.disabled = true;
        Cart.add(v[0]).finally(() => {
          it.open = false;
          card.classList.remove('is-touch-open');
          $('[data-gl-toggle]', card)?.setAttribute('aria-expanded', 'false');
          renderBuy(ci);
        });
      }
    });
    // Escape cierra el panel de compra abierto
    sec.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const card = e.target.closest('[data-gl]');
      if (!card) return;
      const ci = Number(card.dataset.gl);
      card.classList.remove('is-touch-open');
      cards[ci].items.forEach((it) => { it.open = false; });
      renderBuy(ci);
      $('[data-gl-toggle]', card)?.setAttribute('aria-expanded', 'false');
    });
    // los vídeos solo se cargan y reproducen cuando se ven
    const vids = $$('video[data-src]', sec);
    if (vids.length && 'IntersectionObserver' in window) {
      const vio = new IntersectionObserver((entries) => entries.forEach((en) => {
        const v = en.target;
        if (en.isIntersecting) { if (!v.getAttribute('src')) v.src = v.dataset.src; if (!reduceMotion) v.play().catch(() => {}); } else v.pause();
      }), { threshold: 0.4 });
      vids.forEach((v) => vio.observe(v));
    }
  }
  $$('[data-looks-section]').forEach(initLooks);
  document.addEventListener('shopify:section:load', (e) => { registerProducts(e.target); $$('[data-looks-section]', e.target).forEach(initLooks); });

  if (typeof registerProducts === 'function') registerProducts(document);
})();
